// ================= IMPORTS =================
import { useState, useEffect, useMemo } from "react";
import ConsentNoticeModel from "./Consent-notice-model";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import { uwinAPI } from "../../../services/uwin.api";
import MobileNumberInput from "./MobileNumberInputNew";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { calculateAge, decryptOpenSSLAES, formatDobForAPI, maskAbhaNumber } from "../../../helpers/common-uwinhelper";
import { getAadhaarHelperText, validateAadhaar } from "../../../helpers/abdm-helper";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// MUI Imports
import {
    Box,
    Grid,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Checkbox,
    Button,
    Typography,
    IconButton,
    FormHelperText,
} from "@mui/material";

// ================= COMPONENT =================
const PreResgistrationUwin = ({ onClose }) => {
    // ================= MASTER DATA =================
    const [facilitiesSessions, setFacilitiesSessions] = useState([]);
    const [sessionSites, setSessionSites] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [photoIdTypes, setPhotoIdTypes] = useState([]);
    const [existingMemebers, setExistingMemebers] = useState([]);

    // ================= FORM STATES (FIELD WISE) =================
    const [facilityId, setFacilityId] = useState("");
    const [sessionSiteId, setSessionSiteId] = useState("");
    const [mobile, setMobile] = useState("");
    const [confirmMobile, setConfirmMobile] = useState("");
    const [name, setName] = useState("");
    const [dob, setDob] = useState("");
    const [gender, setGender] = useState("");
    const [yearOfBirth, setYearOfBirth] = useState("");
    const [minDate, setMinDate] = useState("");
    const [maxDate, setMaxDate] = useState("");
    const [benTypeId, setBenTypeId] = useState("");
    const [photoIdType, setPhotoIdType] = useState("");
    const [photoIdTypeName, setPhotoIdTypeName] = useState("");
    const [photoIdNumber, setPhotoIdNumber] = useState("");
    const [isPvtg, setIsPvtg] = useState("No");

    // Pregnant
    const [lmcDate, setLmcDate] = useState("");
    const [bloodGroup, setBloodGroup] = useState("");
    const [prevPregnancy, setPrevPregnancy] = useState("");
    const [tdDose, setTdDose] = useState("");

    // Child / Infant
    const [childWeight, setChildWeight] = useState("");
    const [fatherName, setFatherName] = useState("");
    const [guardianId, setGuardianId] = useState("");
    const [relationWithGuardian, setRelationWithGuardian] = useState("");
    const [relationGender, setRelationGender] = useState("");

    // Consent
    const [consentBox, setConsentBox] = useState(false);
    const [consentBoxHardCopy, setConsentBoxHardCopy] = useState(false);

    // UI
    const [errors, setErrors] = useState({});
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [consentModel, setConsentModel] = useState(false);

    const orignalBeneficiaryData =
        JSON.parse(localStorage.getItem("orignalBeneficiaryData")) || {};
    const loggedinUserdetails =
        JSON.parse(localStorage.getItem("uwin_loggedinUserdetails")) || {};
    const isNewRegistration = localStorage.getItem("uwin_new_regitration");
    console.log("isNewRegistration: ", isNewRegistration, typeof isNewRegistration);
    // const isNewRegistration = false;
    const selectedCategory =
        categoryOptions.find((c) => c.id === benTypeId)?.ben_type_decrypted;

    const isCititzen = selectedCategory === "Cititzen";
    const isPregnant = selectedCategory === "Pregnant Woman";
    const isInfant = selectedCategory === "Infant";
    const isChild = selectedCategory === "Children";
    const isAdolescent = selectedCategory === "Adolescent";
    const isNewBornBaby = selectedCategory === "New Born Baby";
    const isDPM = (loggedinUserdetails.rolename === "Delivery Point Manager");
    const isDPM_OR_Vaccinator = loggedinUserdetails.rolename === "Both(Vaccinator & Delivery Manager)";
    const isAsha = loggedinUserdetails.rolename === "ASHA";

    //onSite Regsitration flag from session details
    const navigate = useNavigate();
    const location = useLocation();
    const sessionId = location.state?.sessionId;
    const isOnSiteRegistration = location.state?.isOnSiteRegistration || false;
    const isABHAExisting = !!orignalBeneficiaryData.hidn;

    const resetAllState = () => {
        setFacilityId("");
        setSessionSiteId("");
        setMobile("");
        setConfirmMobile("");
        setName("");
        setDob("");
        setGender("");
        setYearOfBirth("");
        setMinDate("");
        setMaxDate("");
        setBenTypeId("");
        setPhotoIdType("");
        setPhotoIdNumber("");
        setIsPvtg("No");
        setLmcDate("");
        setBloodGroup("");
        setPrevPregnancy("");
        setTdDose("");
        setChildWeight("");
        setFatherName("");
        setGuardianId("");
        setRelationWithGuardian("");
    };

    useEffect(() => {
        setPhotoIdType("");
        setPhotoIdNumber("");
        setPhotoIdTypeName("");
        setIsPvtg("No");
        setLmcDate("");
        setBloodGroup("");
        setPrevPregnancy("");
        setTdDose("");
        setChildWeight("");
        setFatherName("");
        setGuardianId("");
        setRelationWithGuardian("");
    }, [benTypeId]);

    // FIX: Sync relationWithGuardian when relationGender changes
    useEffect(() => {
        if (relationGender === "Male") {
            setRelationWithGuardian("Father");
        } else if (relationGender === "Female") {
            setRelationWithGuardian("Mother");
        } else {
            setRelationWithGuardian("");
        }
    }, [relationGender]);

    useEffect(() => {
        // Trigger default filter on session site change (Requirement 1)
        console.log("Session site changed: ", sessionSiteId);
    }, [sessionSiteId]);


    // Handle Photo ID Number Change with Aadhaar formatting
    const handlePhotoIdNumberChange = (e) => {
        let value = e.target.value;
        const isAadhaar = photoIdTypeName?.toLowerCase().trim() === "aadhaar card";

        if (isAadhaar) {
            value = value.replace(/\D/g, ""); // Remove non-digits
            if (value.length > 12) value = value.slice(0, 12);

            // Add hyphens
            if (value.length > 8) {
                value = value.slice(0, 4) + "-" + value.slice(4, 8) + "-" + value.slice(8);
            } else if (value.length > 4) {
                value = value.slice(0, 4) + "-" + value.slice(4);
            }
        }
        setPhotoIdNumber(value);
    };

    // Aadhaar Validation State
    const isAadhaarSelected = photoIdTypeName?.toLowerCase().trim() === "aadhaar card";
    const { isValid: isAadhaarValid, cleanAadhaar: cleanedAadhaar } = isAadhaarSelected
        ? validateAadhaar(photoIdNumber)
        : { isValid: true, cleanAadhaar: "" };

    // Calculate min and max dates
    const createSafeDate = (y, m, d) => new Date(y, m, d, 12, 0, 0); // 12:00 PM LOCAL

    const dateConstraints = useMemo(() => {
        const now = new Date();

        const lmcMinDate = createSafeDate(
            now.getFullYear() - 1,
            now.getMonth(),
            now.getDate()
        );

        const lmcMaxDate = createSafeDate(
            now.getFullYear(),
            now.getMonth(),
            now.getDate()
        );

        let prevPregnancyMinDate = null;
        let prevPregnancyMaxDate = createSafeDate(
            now.getFullYear(),
            now.getMonth(),
            now.getDate()
        );

        if (dob) {
            const [y, m, d] = dob.split("-").map(Number);
            const dobSafe = createSafeDate(y, m - 1, d);
            prevPregnancyMinDate = createSafeDate(
                dobSafe.getFullYear() + 12,
                dobSafe.getMonth(),
                dobSafe.getDate()
            );
        }

        if (lmcDate) {
            const [y, m, d] = lmcDate.split("-").map(Number);
            const lmcSafe = createSafeDate(y, m - 1, d);
            prevPregnancyMaxDate = createSafeDate(
                lmcSafe.getFullYear(),
                lmcSafe.getMonth() - 1,
                lmcSafe.getDate()
            );
        }

        return {
            lmcMinDate,
            lmcMaxDate,
            prevPregnancyMinDate,
            prevPregnancyMaxDate,
        };
    }, [dob, lmcDate]);

    const shouldShowTdDoses = (lmc_date, previous_pregnancy_year) => {
        if (!lmc_date || !previous_pregnancy_year) {
            return false;
        }

        const [ly, lm, ld] = lmc_date.split("-").map(Number);
        const [py, pm, pd] = previous_pregnancy_year.split("-").map(Number);

        const lmcSafe = createSafeDate(ly, lm - 1, ld);
        const prevPregSafe = createSafeDate(py, pm - 1, pd);

        const diffMs = lmcSafe - prevPregSafe;
        const diffYears = diffMs / (1000 * 60 * 60 * 24 * 365.25);

        return diffYears < 3;
    };

    useEffect(() => {
        if (isPregnant) {
            setGender("Female");
        }
    }, [isPregnant]);

    useEffect(() => {
        if (isDPM) {
            setGender("Female")
        }
    }, isDPM)

    useEffect(() => {
        if (dob) {
            generateCategoryOptions(dob);
            PhotoIdTypes(dob);
        }
    }, [dob]);

    useEffect(() => {
        // Don't validate if user is still typing (less than 4 digits)
        if (!yearOfBirth || yearOfBirth.length < 4) {
            return;
        }

        const numericYear = parseInt(yearOfBirth, 10);
        const today = new Date();
        const currentYear = today.getFullYear();
        const newErrors = {};

        if (!numericYear || numericYear < 1900 || numericYear > currentYear) {
            newErrors.yearOfBirth = "The entered Year of Birth does not qualify for Registration";
            setErrors(newErrors);
            return;
        }

        setErrors({});
        setYearOfBirth(numericYear);
        const startDate = `${numericYear}-01-01`;
        let endDate = `${numericYear}-12-31`;

        if (numericYear === currentYear) {
            const todayStr = today.toISOString().split("T")[0];
            endDate = todayStr;
        }
        generateCategoryOptions(startDate);
        PhotoIdTypes(startDate);
        setMinDate(startDate);
        setMaxDate(endDate);
        setDob(startDate);
    }, [yearOfBirth]);

    const PhotoIdTypes = async (dob) => {
        if (!dob) return [];

        await getClientToken();
        setIsPageLoading(true);

        const dtresponsePhotoId = await uwinAPI.getPhotoIdTypes({ dob });

        setIsPageLoading(false);

        if (dtresponsePhotoId.success) {
            const data = dtresponsePhotoId.data || [];
            setPhotoIdTypes(data);
            return data;
        } else {
            setPhotoIdTypes([]);
            return [];
        }
    };

    const handleGaurdianDetailsChange = async (selectedGuardianId) => {
        // Reset fields first
        setFatherName("");

        // Find the selected member from existingMemebers array
        const selectedMember = existingMemebers.find(
            (member) => member.beneficiary_id === selectedGuardianId
        );

        if (!selectedMember) return;

        // Format DOB from the member object
        const dobFormatted = formatDobForAPI(selectedMember.dob);
        const dtPhotoIdTypes = await PhotoIdTypes(dobFormatted);

        if (dtPhotoIdTypes.length > 0 && selectedMember.photo_id_type) {

            const matchedPhotoId = dtPhotoIdTypes.find(
                (option) => option.photo_type === decryptOpenSSLAES(selectedMember.photo_id_type)
            );
            if (matchedPhotoId) {
                setPhotoIdType(matchedPhotoId.id);
                setPhotoIdTypeName(matchedPhotoId.photo_type);
                setPhotoIdNumber(decryptOpenSSLAES(selectedMember.photo_id_number) || "");
            }
        }

        // Set relation based on gender from member object
        if (selectedMember.beneficiary_gender === "Male") {
            setRelationWithGuardian("Father");
            setRelationGender("Male");
            setFatherName(selectedMember.ben_name || "");
        } else if (selectedMember.beneficiary_gender === "Female") {
            setRelationWithGuardian("Mother");
            setRelationGender("Female");
        } else {
            setRelationWithGuardian("");
            setFatherName("");
        }
    };

    // ================= API HELPERS =================
    const encryptText = async (text) => {
        const token = localStorage.getItem("Backend_token");
        const res = await axios.post(
            "nodeapi/uwin/encryption",
            { plaintext: text },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return res.data.data.encrypted;
    };

    const getClientToken = async () => {
        const user = JSON.parse(localStorage.getItem("uwin_loggedinUserdetails"));
        const res = await axios.post("nodeapi/uwin/client-token", {
            user_id: user?.user_id,
        });
        if (res.data.success) {
            localStorage.setItem("uwin_token", res.data.data.accessToken);
        }
    };

    const getYearFromDOB = (dob) => {
        if (!dob) return "";
        const [day, month, year] = dob.split("-");
        return Number(year); // or parseInt(year)
    }

    const convertDOBFormat = (dob) => {
        if (!dob) return "";

        const dateStr = dob.trim().replace(/\//g, "-");

        let day, month, year;

        // DD-MM-YYYY or D-M-YYYY
        if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(dateStr)) {
            [day, month, year] = dateStr.split("-");

            return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
        }

        // YYYY-MM-DD or YYYY-M-D
        if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(dateStr)) {
            [year, month, day] = dateStr.split("-");

            return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
        }

        const date = new Date(dateStr);

        if (isNaN(date.getTime())) {
            return "Invalid Date";
        }

        return `${date.getFullYear()}-${String(
            date.getMonth() + 1
        ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    };

    // ================= INITIAL LOAD =================
    useEffect(() => {
        resetAllState();
        setMobile(orignalBeneficiaryData.mobile || "");
        setConfirmMobile(orignalBeneficiaryData.mobile || "");
        if (!isDPM && !isAsha) {
            getClientToken().then(async () => {
                setIsPageLoading(true);
                const res = await uwinAPI.getFacilitySessionSites();
                if (res?.success) {
                    setIsPageLoading(false);
                    setFacilitiesSessions(res?.data || []);
                } else {
                    setIsPageLoading(false);
                    toast.error("Failed to fetch facilities");
                }
            });
        }
        if (isAsha) {
            getAllAshaSessions();
        }
        // if (orignalBeneficiaryData?.hidn) {
            setYearOfBirth(getYearFromDOB(orignalBeneficiaryData.dob));
            setName(orignalBeneficiaryData.name);
            setGender(
                orignalBeneficiaryData?.gender?.charAt(0)?.toUpperCase() === 'M'
                    ? 'Male'
                    : orignalBeneficiaryData?.gender?.charAt(0)?.toUpperCase() === 'F'
                    ? 'Female'
                    : 'Other'
            );
            console.log("call hu gai kr ke dekho: ", orignalBeneficiaryData.dob);
            setDob(convertDOBFormat(orignalBeneficiaryData.dob));
        // }
    }, []);

    // ================= SEARCH BENEFICIARY =================
    useEffect(() => {
        if (mobile.length === 10) {
            setIsPageLoading(true);
            encryptText(mobile).then(async (enc) => {
                const res = await uwinAPI.searchBeneficiary({
                    search_value: enc,
                    search_by: "mobile-number",
                });
                if (res.success) {
                    setIsPageLoading(false);
                    setExistingMemebers(res.data || []);
                } else {
                    setIsPageLoading(false);
                }
            });
        }
    }, [mobile]);

    useEffect(() => {
        if (isDPM && categoryOptions.length) {
            const pregnantOption = categoryOptions.find(
                (option) => option.ben_type_decrypted === "Pregnant Woman"
            );
            if (pregnantOption) {
                setBenTypeId(pregnantOption.id);
            }
        }
    }, [categoryOptions, isDPM]);

    useEffect(() => {
        setIsPageLoading(true);
        const selectedId = facilityId;
        const facility = facilitiesSessions.find(
            (item) => item.facility_id === selectedId
        );
        if (facility) {
            setIsPageLoading(false);
            setSessionSites(facility.session_sites || []);
        } else {
            setIsPageLoading(false);
            setSessionSites([]);
        }
    }, [facilityId]);

    const generateCategoryOptions = async (dob) => {
        if (!dob) return;
        getClientToken().then(async () => {
            setIsPageLoading(true);
            const dtresponse = await uwinAPI.getBenCategories({ dob });
            if (dtresponse && dtresponse.success) {
                setIsPageLoading(false);
                setCategoryOptions(dtresponse.data || []);
            } else {
                setCategoryOptions([]);
            }
        });
    };

    const getAllAshaSessions = async () => {
        try {
            setIsPageLoading(true);
            getClientToken().then(async () => {
                const response = await uwinAPI.getAllAshaSessionSites();

                if (response?.success) {
                    const data = response?.data || [];
                    setSessionSites(data);
                    if (data.length > 0) {
                        setSessionSites(data || []);
                    }
                }
            })
        } catch (error) {
            toast.error(error?.response?.data?.message?.error || "Failed to fetch session sites");
        } finally {
            setIsPageLoading(false);
        }
    };

    // ================= VALIDATION =================
    const validate = () => {
        let newErrors = {};
        if (isDPM && !isPregnant) {
            newErrors.yearOfBirth = "The entered Year of Birth does not qualify for Registration";
        }
        if (!facilityId && !isDPM && !isDPM_OR_Vaccinator && !isAsha) {
            newErrors.facilityId = "Facility required";
        }
        if (!sessionSiteId && !isDPM && !isDPM_OR_Vaccinator) {
            newErrors.sessionSiteId = "Session site required";
        }
        if (!mobile) {
            newErrors.mobile = "Mobile number required";
        }
        if (mobile && !/^[6-9]\d{9}$/.test(mobile)) {
            newErrors.mobile = "Invalid mobile number";
        }
        if (!confirmMobile) {
            newErrors.confirmMobile = "Please confirm mobile number";
        }
        if (confirmMobile && !/^[6-9]\d{9}$/.test(confirmMobile)) {
            newErrors.confirmMobile = "Invalid confirm mobile number";
        }
        if (mobile !== confirmMobile) {
            newErrors.confirmMobile = "confirm mobile number does not match mobile number";
        }
        if (!name) {
            newErrors.name = "Name required";
        }
        if (!yearOfBirth) {
            newErrors.yearOfBirth = "Year of birth required";
        }
        if (!dob) {
            newErrors.dob = "DOB required";
        }
        if (!gender) {
            newErrors.gender = "Gender required";
        }
        if (!photoIdType) {
            newErrors.photoIdType = "Photo ID required";
        }
        if (!photoIdNumber) {
            newErrors.photo_id_number = "Photo ID number required";
        }
        if (!isChild && !isInfant && !isNewBornBaby) {

            if (
                photoIdTypeName?.toLowerCase().trim() === "aadhaar card" &&
                !isAadhaarValid
            ) {
                newErrors.photo_id_number = getAadhaarHelperText(photoIdNumber, cleanedAadhaar, isAadhaarValid) || "Invalid Aadhaar number";
            } else if (
                photoIdTypeName?.toLowerCase().trim() === "passport" &&
                !/^[A-Z][0-9]{7}$/.test(photoIdNumber)
            ) {
                newErrors.photo_id_number = "Invalid Passport number (1 letter + 7 digits)";
            } else if (
                photoIdTypeName?.toLowerCase().trim() === "driving license" &&
                !/^[A-Z0-9]{8,15}$/i.test(photoIdNumber)
            ) {
                newErrors.photo_id_number = "Invalid Driving License number";
            } else if (
                photoIdTypeName?.toLowerCase().trim() === "pan card" &&
                !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(photoIdNumber)
            ) {
                newErrors.photo_id_number = "Invalid PAN number (Format: ABCDE1234F)";
            } else if (
                photoIdTypeName?.toLowerCase().trim() === "ABHA NUmber" &&
                !/^\d{2}-\d{4}-\d{4}-\d{4}$/.test(photoIdNumber)
            ) {
                newErrors.photo_id_number = "Invalid ABHA ID (Format: 12-3456-7890-1234)";
            } else if (
                photoIdTypeName?.toLowerCase().trim() === "birth certificate" &&
                !/^[A-Z0-9\-\/]{5,20}$/i.test(photoIdNumber)
            ) {
                newErrors.photo_id_number = "Invalid Birth Certificate number";
            }
        }
        if (!benTypeId) {
            newErrors.benTypeId = "Category required";
        }

        if (isPregnant && !lmcDate) {
            newErrors.lmc_date = "LMC date required";
        }

        if (
            (isInfant || isChild || isNewBornBaby) &&
            existingMemebers.length &&
            !guardianId
        ) {
            newErrors.guardian_ben_id = "Primary Guardian required";
        }
        return newErrors;
    };

    // ================= SUBMIT =================
    const handleSubmit = async (e) => {
        e.preventDefault();
        const formErrors = validate();
        if (Object.keys(formErrors).length !== 0) {
            setErrors(formErrors);
            console.log("Validation errors: ", formErrors);
            return;
        }
        try {
            setIsPageLoading(true);

            const payload = {
                session_id: sessionId || undefined,
                facility_id: (isDPM || isDPM_OR_Vaccinator) ? await encryptText(loggedinUserdetails.facilityTypeId) : undefined,
                session_site_id: sessionSiteId ? sessionSiteId : undefined,
                mobile_number: mobile ? await encryptText(mobile) : undefined,
                name,
                dob,
                gender,
                ben_type_id: benTypeId,
                is_pvtg: isPvtg,
                lmc_date: isPregnant ? lmcDate : undefined,
                blood_group: bloodGroup || undefined,
                previous_pregnancy_year: prevPregnancy || undefined,
                td_doses_received: tdDose || undefined,
                child_weight: childWeight || undefined,
                father_name: fatherName || undefined,
                guardian_ben_id: guardianId || undefined,
                relation_with_guardian: relationWithGuardian || undefined,
                consent_otp_registration: `${consentBox}`,
                hardcopy_consent_received: `${consentBoxHardCopy}`,
                username: loggedinUserdetails.username || "",
                platform: "Web",
            };
            if (!isChild && !isInfant && !isNewBornBaby) {
                if (photoIdType) {
                    payload.photo_id_type_id = photoIdType;
                }
                if (photoIdNumber) {
                    payload.photo_id_number = await encryptText(photoIdNumber);
                }
            }

            Object.keys(payload).forEach((key) => {
                if (
                    payload[key] === undefined ||
                    payload[key] === null ||
                    payload[key] === ""
                ) {
                    delete payload[key];
                }
            });

            await getClientToken();

            const res = await uwinAPI.registerPatient(payload);

            if (res.success) {
                toast.success("Registration successful");
                if (isOnSiteRegistration) {
                    setTimeout(() => {
                        navigate(-1);
                    }, 3000);
                } else {
                    window.location.reload();
                }

            } else {
                toast.error(res.message || "Failed");
            }
        } catch (error) {
            console.error("API Error: ", error);

            if (error.response) {
                toast.error(
                    error.response.data?.message || `Error ${error.response.status}`
                );
            } else if (error.request) {
                toast.error("No response from server");
            } else {
                toast.error("Something went wrong");
            }
        } finally {
            setIsPageLoading(false);
        }
    };

    const memberCount = existingMemebers?.length || 0;

    const guardianLabel =
        (isInfant || isChild || isNewBornBaby)
            ? `Select Primary Guardian * (${memberCount})`
            : `Existing Members (${memberCount})`;
    const PageTitle = isOnSiteRegistration ? "On-site Registration" : isDPM ? "Register Pregnant Women" : "U-WIN Pre Registration";

    useEffect(() => {
        if (orignalBeneficiaryData?.hidn && (!isChild && !isInfant && !isNewBornBaby)) {
            const abhaOption = photoIdTypes.find(
                (item) => item.photo_type === "ABHA NUMBER"
            );

            if (abhaOption) {
                setPhotoIdType(abhaOption.id);
                setPhotoIdNumber(orignalBeneficiaryData.hidn);
            }
        }
    }, [orignalBeneficiaryData, photoIdTypes]);

    // ================= JSX =================
    return (
        <>
            {isPageLoading && <Loader />}
            <Box className="uwinNewRegistrationPre program-selection-sectionn" sx={{ p: 2 }}>
                <Box className="patientDetailsTitleHeader-h d-flex mb-0" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Box className="leftHeaderBar">
                        <Typography variant="h4" sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box component="img" src="/images/uwin.svg" alt="" sx={{ width: 60, mb: 0.5, mr: 1 }} />
                            {PageTitle}
                        </Typography>
                    </Box>
                    {isOnSiteRegistration ? (
                        <ArrowBackIcon
                            className="cursor-pointer"
                            onClick={() => navigate(-1)}
                        />
                    ) : (
                        <IconButton onClick={() => onClose("handleCloseNikshayresistation")} className="closeDive nikshayclose">
                            <CloseIcon />
                        </IconButton>
                    )
                    }
                </Box>

                <form onSubmit={handleSubmit}>
                    {(!isDPM && !isDPM_OR_Vaccinator) && (
                        <Box className="feildsSection" sx={{ mb: 3 }}>
                            <Box className="uwinfeildsTitle">
                                <Typography variant="h5">Facility Details</Typography>
                            </Box>
                            <Box className="uwinFeildsBody">
                                <Grid container spacing={2}>
                                    {(!isAsha) && (
                                        <Grid size={{ xs: 12, md: 6 }}>
                                            <FormControl fullWidth error={!!errors.facilityId}>
                                                <InputLabel id="facility-label">Select Facility</InputLabel>
                                                <Select
                                                    labelId="facility-label"
                                                    name="facility_id"
                                                    value={facilityId}
                                                    label="Select Facility"
                                                    onChange={(e) => setFacilityId(e.target.value)}
                                                >
                                                    <MenuItem value="">-- Select Facility --</MenuItem>
                                                    {facilitiesSessions &&
                                                        facilitiesSessions.map((facility) => (
                                                            <MenuItem value={facility.facility_id} key={facility.facility_id}>
                                                                {facility.facility_name}
                                                            </MenuItem>
                                                        ))}
                                                </Select>
                                                {errors.facilityId && (
                                                    <FormHelperText>{errors.facilityId}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                    )}
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <FormControl fullWidth error={!!errors.sessionSiteId}>
                                            <InputLabel id="session-label">Session Sites</InputLabel>
                                            <Select
                                                labelId="session-label"
                                                name="session_site_id"
                                                value={sessionSiteId}
                                                label="Session Sites"
                                                onChange={(e) => setSessionSiteId(e.target.value)}
                                            >
                                                <MenuItem value="">-- Select Session Sites --</MenuItem>
                                                {sessionSites &&
                                                    sessionSites.map((site) => (
                                                        <MenuItem value={site.session_site_id} key={site.session_site_id}>
                                                            {site.session_site_name}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                            {errors.sessionSiteId && (
                                                <FormHelperText>{errors.sessionSiteId}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    )}
                    <Box className="feildsSection" sx={{ mb: 3 }}>
                        <Box className="uwinfeildsTitle">
                            <Typography variant="h5">Personal Details</Typography>
                        </Box>
                        <Box className="uwinFeildsBody">
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12, md: 3 }}>
                                    <Grid item xs={12} md={3}>
                                        <MobileNumberInput
                                            mobile={mobile}
                                            setMobile={setMobile}
                                            errors={errors}
                                            isOnSiteRegistration={isOnSiteRegistration}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid size={{ xs: 12, md: 3 }}>
                                    <TextField
                                        fullWidth
                                        label="Confirm Mobile Number *"
                                        name="confirm_mobile_number"
                                        value={confirmMobile}
                                        disabled={!!orignalBeneficiaryData.mobile && !isOnSiteRegistration}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            // sirf numbers allow
                                            if (!/^\d*$/.test(value)) return;

                                            // 10 digits se zyada allow nahi
                                            if (value.length > 10) return;

                                            if (value && !/^[6-9]\d{9}$/.test(value)) {
                                                errors.confirmMobile = "Invalid confirm mobile number";
                                            } else {
                                                delete errors.confirmMobile;
                                            }
                                            setConfirmMobile(value);
                                        }}
                                        error={!!errors.confirmMobile}
                                        helperText={errors.confirmMobile}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, md: 3 }}>
                                    <TextField
                                        fullWidth
                                        label="Full Name *"
                                        name="name"
                                        value={name}
                                        disabled={isNewRegistration === "1"}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^[A-Za-z\s]*$/.test(value)) {
                                                setName(value);
                                            }
                                        }}
                                        inputProps={{ minLength: 3, maxLength: 20, autoComplete: "off" }}
                                        error={!!errors.name}
                                        helperText={errors.name}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, md: 3 }}>
                                    <TextField
                                        fullWidth
                                        label="Year of Birth"
                                        name="year_of_birth"
                                        type="number"
                                        value={yearOfBirth}
                                        disabled={isNewRegistration === "1"}
                                        onChange={(e) => setYearOfBirth(e.target.value)}
                                        inputProps={{
                                            min: 1900,
                                            max: new Date().getFullYear(),
                                            inputMode: "numeric",
                                            pattern: "[0-9]*"
                                        }}
                                        error={!!errors.yearOfBirth}
                                        helperText={errors.yearOfBirth}
                                    />
                                </Grid>

                                {yearOfBirth && yearOfBirth >= 2007 && yearOfBirth <= new Date().getFullYear() && (
                                    <Grid size={{ xs: 12, md: 3 }}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                label="Date Of Birth *"
                                                format="DD-MM-YYYY"
                                                value={dob ? dayjs(dob) : null}
                                                onChange={(newValue) => {
                                                    setDob(newValue ? newValue.format("YYYY-MM-DD") : "");
                                                }}
                                                minDate={minDate ? dayjs(minDate) : undefined}
                                                maxDate={maxDate ? dayjs(maxDate) : undefined}
                                                disabled={!minDate || !maxDate}
                                                slotProps={{
                                                    textField: {
                                                        fullWidth: true,
                                                        error: !!errors.dob,
                                                        helperText: errors.dob,
                                                        autoComplete: "off"
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                )}

                                <Grid size={{ xs: 12, md: 3 }}>
                                    <FormControl fullWidth error={!!errors.benTypeId}>
                                        <InputLabel id="category-label">Type of Category *</InputLabel>
                                        <Select
                                            labelId="category-label"
                                            name="ben_type_id"
                                            value={benTypeId}
                                            label="Type of Category *"
                                            onChange={(e) => {
                                                setBenTypeId(e.target.value)
                                                setGender("")
                                            }}
                                            disabled={isDPM}
                                        >
                                            <MenuItem value="">-- Select Category Type --</MenuItem>
                                            {categoryOptions.map((option) => {
                                                const isMale = (gender === "Male");

                                                let isDisabled = false;

                                                // 👉 If no hidn, disable ABHA
                                                if (isMale && option.ben_type_decrypted == 'Pregnant Woman') {
                                                    // alert();
                                                    isDisabled = true;
                                                }

                                                return (
                                                    <MenuItem key={option.id} value={option.id} disabled={isDisabled}>
                                                        {option.ben_type_decrypted || option.name || option.display}
                                                    </MenuItem>
                                                );
                                            })}
                                            {/* {categoryOptions.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.ben_type_decrypted || option.name || option.display}
                                                </MenuItem>
                                            ))} */}
                                        </Select>
                                        {errors.benTypeId && (
                                            <FormHelperText>{errors.benTypeId}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>

                                <Grid size={{ xs: 12, md: 4 }}>
                                    <FormControl component="fieldset" error={!!errors.gender}>
                                        <Typography variant="subtitle2" gutterBottom>Gender *</Typography>
                                        <RadioGroup
                                            row
                                            name="gender"
                                            value={gender}
                                            onChange={(e) => {
                                                setGender(e.target.value)
                                            }}
                                        >
                                            <FormControlLabel
                                                value="Male"
                                                control={<Radio />}
                                                label="Male"
                                                disabled={(isPregnant || isDPM) || (isNewRegistration === "1")}
                                            />
                                            <FormControlLabel
                                                value="Female"
                                                control={<Radio />}
                                                label="Female"
                                                // checked={isPregnant || isDPM}
                                                disabled={(isPregnant || isDPM) || (isNewRegistration === "1")}
                                            />
                                            <FormControlLabel
                                                value="Other"
                                                control={<Radio />}
                                                label="Other"
                                                disabled={(isPregnant || isDPM) || (isNewRegistration === "1")}
                                            />
                                        </RadioGroup>
                                        {errors.gender && (
                                            <FormHelperText>{errors.gender}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>

                                {!isCititzen && (
                                    <Grid size={{ xs: 12, md: 2 }}>
                                        <FormControl component="fieldset" error={!!errors.isPvtg}>
                                            <Typography variant="subtitle2" gutterBottom>PVTG *</Typography>
                                            <RadioGroup
                                                row
                                                name="is_pvtg"
                                                value={isPvtg}
                                                onChange={(e) => setIsPvtg(e.target.value)}
                                            >
                                                <FormControlLabel value="No" control={<Radio />} label="No" />
                                                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                            </RadioGroup>
                                            {errors.isPvtg && (
                                                <FormHelperText>{errors.isPvtg}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                )}

                                <Grid size={{ xs: 12, md: 3 }}>
                                    <FormControl fullWidth error={!!errors.photoIdType}>
                                        <InputLabel id="photo-id-label">Photo ID Type *</InputLabel>
                                        <Select
                                            labelId="photo-id-label"
                                            name="photo_id_type_id"
                                            value={photoIdType}
                                            label="Photo ID Type *"
                                            disabled={(isChild || isInfant || isNewBornBaby || isABHAExisting)}
                                            onChange={(e) => {
                                                const selectedOption = photoIdTypes.find(opt => opt.id == e.target.value);
                                                setPhotoIdType(e.target.value);
                                                setPhotoIdTypeName(selectedOption?.photo_type || '');
                                                setPhotoIdNumber("");
                                            }}
                                        >
                                            <MenuItem value="">-- Select Photo ID Type --</MenuItem>
                                            {photoIdTypes.map((option) => {
                                                const isAbha = option.photo_type === "ABHA NUMBER";

                                                let isDisabled = false;

                                                // 👉 If no hidn, disable ABHA
                                                if (!orignalBeneficiaryData?.hidn && isAbha) {
                                                    isDisabled = true;
                                                }

                                                return (
                                                    <MenuItem
                                                        key={option.id}
                                                        value={option.id}
                                                        disabled={isDisabled}
                                                    >
                                                        {option.photo_type}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                        {errors.photoIdType && (
                                            <FormHelperText>{errors.photoIdType}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>

                                <Grid size={{ xs: 12, md: 3 }}>
                                    <TextField
                                        fullWidth
                                        label="Photo ID Number *"
                                        name="photo_id_number"
                                        value={photoIdNumber}
                                        onChange={handlePhotoIdNumberChange}
                                        disabled={(isChild || isInfant || isNewBornBaby || isABHAExisting)}
                                        inputProps={{
                                            autoComplete: "off",
                                            maxLength: isAadhaarSelected ? 14 : undefined
                                        }}
                                        error={!!errors.photo_id_number || ((isAadhaarSelected && (!isChild && !isInfant && !isNewBornBaby)) && photoIdNumber.length > 0 && !isAadhaarValid)}
                                        helperText={errors.photo_id_number || ((isAadhaarSelected && (!isChild && !isInfant && !isNewBornBaby)) ? getAadhaarHelperText(photoIdNumber, cleanedAadhaar, isAadhaarValid) : "")}
                                    />
                                </Grid>

                                {isPregnant && (
                                    <>
                                        <Grid size={{ xs: 12, md: 2 }}>
                                            <FormControl fullWidth>
                                                <InputLabel id="blood-group-label">Blood Group</InputLabel>
                                                <Select
                                                    labelId="blood-group-label"
                                                    name="blood_group"
                                                    value={bloodGroup}
                                                    label="Blood Group"
                                                    onChange={(e) => setBloodGroup(e.target.value)}
                                                >
                                                    <MenuItem value="">-- Select Blood Group --</MenuItem>
                                                    <MenuItem value="A+ve">A+</MenuItem>
                                                    <MenuItem value="A-ve">A-</MenuItem>
                                                    <MenuItem value="B+ve">B+</MenuItem>
                                                    <MenuItem value="B-ve">B-</MenuItem>
                                                    <MenuItem value="AB+ve">AB+</MenuItem>
                                                    <MenuItem value="AB-ve">AB-</MenuItem>
                                                    <MenuItem value="O+ve">O+</MenuItem>
                                                    <MenuItem value="O-ve">O-</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid size={{ xs: 12, md: 4 }}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label="Date of Last Menstrual Period *"
                                                    format="DD-MM-YYYY"
                                                    value={lmcDate ? dayjs(lmcDate) : null}
                                                    onChange={(newValue) => setLmcDate(newValue ? newValue.format("YYYY-MM-DD") : "")}
                                                    minDate={dayjs(dateConstraints.lmcMinDate)}
                                                    maxDate={dayjs(dateConstraints.lmcMaxDate)}
                                                    slotProps={{
                                                        textField: {
                                                            fullWidth: true,
                                                            error: !!errors.lmc_date,
                                                            helperText: errors.lmc_date,
                                                            autoComplete: "off"
                                                        }
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>

                                        <Grid size={{ xs: 12, md: 4 }}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label="Date of last Pregnancy Outcome"
                                                    format="DD-MM-YYYY"
                                                    value={prevPregnancy ? dayjs(prevPregnancy) : null}
                                                    onChange={(newValue) => {
                                                        const formatted = newValue ? newValue.format("YYYY-MM-DD") : "";
                                                        setPrevPregnancy(formatted);
                                                        if (!shouldShowTdDoses(lmcDate, formatted)) {
                                                            setTdDose("");
                                                        }
                                                    }}
                                                    minDate={dateConstraints.prevPregnancyMinDate ? dayjs(dateConstraints.prevPregnancyMinDate) : undefined}
                                                    maxDate={dateConstraints.prevPregnancyMaxDate ? dayjs(dateConstraints.prevPregnancyMaxDate) : undefined}
                                                    slotProps={{
                                                        textField: {
                                                            fullWidth: true,
                                                            autoComplete: "off"
                                                        }
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>

                                        {shouldShowTdDoses(lmcDate, prevPregnancy) && (
                                            <>
                                                <Grid size={{ xs: 12, md: 3 }}>
                                                    <FormControl component="fieldset">
                                                        <Typography variant="subtitle2" gutterBottom>TD Doses</Typography>
                                                        <RadioGroup
                                                            row
                                                            name="td_doses_received"
                                                            value={tdDose}
                                                            onChange={(e) => setTdDose(e.target.value)}
                                                        >
                                                            <FormControlLabel value="0" control={<Radio />} label="Dose 0" />
                                                            <FormControlLabel value="1" control={<Radio />} label="Dose 1" />
                                                            <FormControlLabel value="2" control={<Radio />} label="Dose 2" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 3 }}>
                                                    <FormControl component="fieldset">
                                                        <Typography variant="subtitle2" gutterBottom>TD Booster</Typography>
                                                        <RadioGroup
                                                            row
                                                            name="td_doses_received"
                                                            value={tdDose}
                                                            onChange={(e) => setTdDose(e.target.value)}
                                                        >
                                                            <FormControlLabel value="3" control={<Radio />} label="Booster" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Grid>
                                            </>
                                        )}
                                    </>
                                )}

                                {(isInfant || isNewBornBaby) && (
                                    <>
                                        <Grid size={{ xs: 12, md: 3 }}>
                                            <TextField
                                                fullWidth
                                                label="Child Weight at Birth In KG's"
                                                name="child_weight"
                                                type="number"
                                                value={childWeight}
                                                onChange={(e) => setChildWeight(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid size={{ xs: 12, md: 3 }}>
                                            <TextField
                                                fullWidth
                                                label="Father's Name"
                                                name="father_name"
                                                value={fatherName}
                                                onChange={(e) => setFatherName(e.target.value)}
                                                inputProps={{ autoComplete: "off" }}
                                            />
                                        </Grid>
                                    </>
                                )}

                                {(isInfant || isChild || isNewBornBaby) && (
                                    <Grid size={{ xs: 12, md: 3 }}>
                                        <FormControl component="fieldset">
                                            <Typography variant="subtitle2" gutterBottom>Relationship of child to Guardian</Typography>
                                            <RadioGroup
                                                row
                                                name="relation_with_guardian"
                                                value={relationWithGuardian}
                                                onChange={(e) => setRelationWithGuardian(e.target.value)}
                                            >
                                                {(relationGender === "Male" || !relationGender) && (
                                                    <FormControlLabel value="Father" control={<Radio />} label="Father" />
                                                )}
                                                {relationGender === "Female" && (
                                                    <FormControlLabel value="Mother" control={<Radio />} label="Mother" />
                                                )}
                                                <FormControlLabel value="Guardian" control={<Radio />} label="Guardian" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                )}

                                {existingMemebers.length > 0 && (
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <FormControl fullWidth error={!!errors.guardian_ben_id}>
                                            <InputLabel id="guardian-label">
                                                {guardianLabel}
                                            </InputLabel>
                                            <Select
                                                labelId="guardian-label"
                                                name="guardian_ben_id"
                                                value={guardianId}
                                                label={guardianLabel}
                                                onChange={(e) => {
                                                    const selectedId = e.target.value;
                                                    setGuardianId(selectedId);
                                                    handleGaurdianDetailsChange(selectedId); // Pass value directly, not event
                                                }}
                                            >
                                                <MenuItem value="">-- Select Beneficiaries --</MenuItem>
                                                {existingMemebers.map((option) => {
                                                    const benType = option.beneficiary_type_name;
                                                    let isDisabled = true;
                                                    if (isInfant || isChild || isNewBornBaby) {
                                                        isDisabled = false;
                                                        if (["Infant", "Children", "Adolescent", "New Born Baby"].includes(benType)) {
                                                            isDisabled = true;
                                                        }
                                                    }

                                                    return (
                                                        <MenuItem
                                                            key={option.beneficiary_id}
                                                            value={option.beneficiary_id}
                                                            disabled={isDisabled}
                                                        >
                                                            {option.ben_name}, {option.beneficiary_gender},{" "}
                                                            {calculateAge(option.dob)?.ageText} | Ref- {maskAbhaNumber(decryptOpenSSLAES(option.beneficiary_reference_id))}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                            {errors.guardian_ben_id && (
                                                <FormHelperText>{errors.guardian_ben_id}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                )}

                                {/* <Grid size={{ xs: 12, md: 9 }}>
                                    <Box className="consent-box-wrapper">
                                        <Box className="checkboxdiclimation">
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={consentBoxHardCopy}
                                                        onChange={() => setConsentBoxHardCopy(!consentBoxHardCopy)}
                                                    />
                                                }
                                                label={
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <InfoOutlinedIcon className="info-icon" sx={{ mr: 1 }} />
                                                        <Typography variant="body2">
                                                            Hard Copy of same consent has been signed by the parent in case internet is not working.
                                                        </Typography>
                                                    </Box>
                                                }
                                                className="consent-label"
                                            />
                                        </Box>
                                    </Box>
                                </Grid> */}

                                <Grid size={{ xs: 12, md: 9 }}>
                                    {/* <Box className="feild">
                                        <Box className="checkboxConsentNotice">
                                            <Box
                                                onClick={() => setConsentModel(true)}
                                                sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                            >
                                                <Checkbox checked={consentBox} readOnly />
                                                <Typography variant="body2">
                                                    Consent Notice... <span style={{ color: 'primary.main' }}>Read More</span>
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box> */}
                                </Grid>

                                {existingMemebers.length < 1 && (isChild || isInfant || isNewBornBaby) ? (
                                    <Grid size={{ xs: 12, md: 9 }}>
                                        <Box className="consent-box-wrapper">
                                            <Box className="checkboxdiclimation">
                                                <Typography variant="body2" className="consent-label">
                                                    Register guardian first to add child.
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                ) : orignalBeneficiaryData.gender !== "Female" && isDPM ? (
                                    <Grid size={{ xs: 12, md: 9 }}>
                                        <Box className="consent-box-wrapper">
                                            <Box className="checkboxdiclimation">
                                                <Typography variant="body2" className="consent-label">
                                                    Male beneficiary registration is not allowed. DPM users can register only pregnant women.
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                ) : (
                                    <Grid
                                        size={{ xs: 12, md: 3 }}
                                        sx={{ display: "flex", justifyContent: "flex-end" }}
                                    >
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            // className={`Save-btn ${!consentBox ? "disabled" : ""}`}
                                            // disabled={!consentBox}
                                        >
                                            Submit
                                        </Button>
                                    </Grid>
                                )}
                            </Grid>
                        </Box>
                    </Box>
                </form>
            </Box>

            {consentModel && (
                <ConsentNoticeModel
                    onClose={() => setConsentModel(false)}
                    consentBox={consentBox}
                    setConsentBox={setConsentBox}
                />
            )}
        </>
    );
};

export default PreResgistrationUwin;